import * as React from 'react';
import { CollapsedText } from '../CollapsedText';
import * as styles from './Description.css';
import { IDescriptionProps } from './types';

export const Description: React.FC<IDescriptionProps> = ({ text, html }) => {
  return (
    <div className={styles['description']}>
      <CollapsedText text={text} lineHeight={22} lineCount={7} html={html} />
    </div>
  );
};
